
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rejestracja-pracownik",
      function () {
        return require("private-next-pages/rejestracja-pracownik.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rejestracja-pracownik"])
      });
    }
  